import Vue from 'vue'
import common from './index'
import regular from './regular'

var validate = {
  // 校验姓名
  validateRealName(rule, value, callback) {
    const reg = regular.realNameRegular
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('请输入真实姓名'))
    } else {
      callback()
    }
  },
  // 不能包含特殊字符
  checkInput(rule, value, callback) {
    var pattern = regular.specialCharacters
    if (!value) {
      callback()
    } else if (pattern.test(value)) {
      callback(new Error('禁止输入特殊字符及空格'))
    } else if (value.indexOf(' ') !== -1) {
      callback(new Error('禁止输入特殊字符及空格'))
    } else {
      callback()
    }
  },
  // 只接受字母或数字
  validateEngOrNum(rule, value, callback) {
    const reg = /^([a-zA-Z0-9]+)$/
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('只能输入字母或数字'))
    } else {
      callback()
    }
  },
  // 只接受数字
  validateNumber(rule, value, callback) {
    const reg = /^([0-9]+)$/
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('只能输入正整数'))
    } else {
      callback()
    }
  },
  // 只接受字母
  validateEnglish(rule, value, callback) {
    const reg = /^([a-zA-Z]+)$/
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('只能输入字母'))
    } else {
      callback()
    }
  },

  // 校验手机号
  validateMobile(rule, value, callback) {
    const reg = regular.mobile
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('请输入正确的11位手机号码'))
    } else {
      callback()
    }
  },
  // 校验邮箱
  validateEmail(rule, value, callback) {
    const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('请输入有效的邮箱'))
    } else {
      callback()
    }
  },
  // 校验身份证号
  validateIDCard(rule, value, callback) {
    // 身份证号合法性验证;支持15位和18位身份证号;支持地址编码、出生日期、校验位验证
    var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外 ' }

    if (!value) {
      callback()
    } else if (!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value)) {
      callback(new Error('身份证号格式错误,请重新输入'))
    } else if (!city[value.substr(0, 2)]) {
      callback(new Error('身份证号地址编码错误,请重新输入'))
    } else {
      // 18位身份证需要验证最后一位校验位
      if (value.length === 18) {
        value = value.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        var sum = 0
        var ai = 0; var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = value[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11] !== value[17].toUpperCase()) {
          // callback(new Error('身份证号校验位错误.请重新输入'))
          callback()
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
  },
  // 校验座机号
  validatePhone(rule, value, callback) {
    const reg = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
    if (!value) {
      callback()
    } else if (!reg.test(value)) {
      callback(new Error('请输入有效的号码,如:0451-82803983'))
    } else {
      callback()
    }
  },
  // 校验IP地址
  validateIP(rule, value, callback) {
    const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if (!value) {
      callback()
    } else {
      var ips = value.split(';')
      for (let i = 0; i < ips.length; i++) {
        if (!reg.test(ips[i])) {
          callback(new Error('请输入正确的IP地址,若输入多个IP地址用英文分号隔开'))
        } else {
          callback()
        }
      }
    }
  },
  // 校验密码规则
  validatePassword(rule, value, callback) {
    if (!value) {
      callback()
    } else if (value.length >= 8 && value.length <= 16 && common._hasNumber(value) && common._hasSmallChar(value) && common._hasBigChar(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的密码(由8-16位组成,包含大写字母、小写字母及数字'))
    }
  }
}
Vue.prototype.commonValidate = validate
export default validate
